import "babel-polyfill";
import { i18n } from "./plugins/vuetify/vuetifyWithTranslationIntegration";

import Vue from "vue";
import IdeasListApp from "./IdeasListApp.vue";
import GlobalSearchResultApp from "./GlobalSearchResultApp.vue";
import Multiselect from "vue-multiselect";
import CwxBtn from "@/components/CwxBtn.vue";
import CwxIcon from "@/components/CwxIcon.vue";
import CwxChip from "@/components/CwxChip.vue";
import CwxImg from "@/components/CwxImg.vue";
import CwxCard from "@/components/CwxCard.vue";
import CwxDataIterator from "@/components/CwxDataIterator.vue";
import CwxLabel from "@/components/CwxLabel.vue";
import CwxTextField from "@/components/CwxTextField.vue";

Vue.config.productionTip = false;

Vue.component("multiselect", Multiselect);
Vue.component("cwx-btn", CwxBtn);
Vue.component("cwx-icon", CwxIcon);
Vue.component("cwx-chip", CwxChip);
Vue.component("cwx-img", CwxImg);
Vue.component("cwx-card", CwxCard);
Vue.component("cwx-data-iterator", CwxDataIterator);
Vue.component("cwx-label", CwxLabel);
Vue.component("cwx-text-field", CwxTextField);
Vue.directive("cwx-tooltip", {
  bind: function(el) {
    $(el).tooltip({
      html: true,
      trigger: "hover"
    });
  },
  unbind: function(el) {
    $(el).tooltip("destroy");
  }
});

const IdeasListAppId = "js-cwx-ideas-list-app";
let elementToMount = document.getElementById(IdeasListAppId);
if (elementToMount) {
  const initDataString = elementToMount.dataset.initData;

  if (!initDataString) {
    throw Error(
      `You need to provide 'data-init-data' argument for component (id=${IdeasListAppId})`
    );
  }

  const initData = JSON.parse(initDataString);

  new Vue({
    render: h =>
      h(IdeasListApp, {
        props: {
          listData: initData
        }
      }),
    i18n
  }).$mount(elementToMount);
}

const GlobalSearchResultAppId = "js-cwx-global-search-result-app";
elementToMount = document.getElementById(GlobalSearchResultAppId);
if (elementToMount) {
  const initDataString = elementToMount.dataset.initData;

  if (!initDataString) {
    throw Error(
      `You need to provide 'data-init-data' argument for component (id=${IdeasListAppId})`
    );
  }

  const initData = JSON.parse(initDataString);

  //TODO: Uncomment this for new vue global search result list.
  //new Vue({
  //  render: h =>
  //    h(GlobalSearchResultApp, {
  //      props: {
  //        data: initData
  //      }
  //    }),
  //  i18n
  //}).$mount(elementToMount);
}
